export default "__VITE_PUBLIC_ASSET__4fbe7085__"